import { render, staticRenderFns } from "./CustomersIndex.vue?vue&type=template&id=b0352466"
import script from "./CustomersIndex.vue?vue&type=script&lang=js"
export * from "./CustomersIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports